import {
  CONSULTAS_INDICADORES_VARIACAO,
  CONSULTAS_CORRELACAO,
  CONSULTAS_CORRELACAO_BENCHMARK,
} from "../const/servicesURI";
import requestService from "./requestService";
import { httpRequests } from "investira.sdk";
import utils from "../utils";

const cancel = {
  indicadores: { variacao: null },
  ativos: { variacao: null },
  correlacao: null,
  correlacaoBenchmarks: null,
};

// TODO: Alterar para POST
export const indicadores = {
  variacao: (pParams = {}, pResolve, pReject, pFinally) => {
    if (cancel.indicadores.variacao) {
      cancel.indicadores.variacao.cancel();
    }

    cancel.indicadores.variacao = httpRequests.cancelToken();

    const xProps = {
      params: pParams,
      cancelToken: cancel.indicadores.variacao.token,
    };

    return requestService(xProps, CONSULTAS_INDICADORES_VARIACAO)
      .then((rRes) => {
        return pResolve && pResolve(rRes);
      })
      .catch((rErr) => {
        utils.request.tracer(
          rErr,
          "Error Service Consultas Indicadores Variação"
        );
        return pReject && pReject(rErr);
      })
      .finally(() => {
        return pFinally && pFinally();
      });
  },
};

// TODO: Alterar para POST
export const ativos = {
  variacao: (pParams = {}, pResolve, pReject, pFinally) => {
    if (cancel.ativos.variacao) {
      cancel.ativos.variacao.cancel();
    }

    cancel.ativos.variacao = httpRequests.cancelToken();

    const xProps = {
      params: pParams,
      cancelToken: cancel.ativos.variacao.token,
    };

    return requestService(xProps, CONSULTAS_INDICADORES_VARIACAO)
      .then((rRes) => {
        return pResolve && pResolve(rRes);
      })
      .catch((rErr) => {
        utils.request.tracer(rErr, "Error Service Consultas Ativos Variação");
        return pReject && pReject(rErr);
      })
      .finally(() => {
        return pFinally && pFinally();
      });
  },
};

export const correlacao = (pProps = {}, pResolve, pReject, pFinally) => {
  const { data, ...restProps } = pProps;
  const xProps = {
    data: data,
    ...restProps,
    method: "POST",
  };

  return requestService(xProps, CONSULTAS_CORRELACAO)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Consultas Correlação");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      return pFinally && pFinally();
    });
};

export const correlacaoBenchmarks = (
  pProps = {},
  pResolve,
  pReject,
  pFinally
) => {
  const { data, ...restProps } = pProps;
  const xProps = {
    data: data,
    ...restProps,
    method: "POST",
    timeout: 5 * 60 * 1000,
  };

  return requestService(xProps, CONSULTAS_CORRELACAO_BENCHMARK)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(
        rErr,
        "Error Service Consultas Correlação Benchmarks"
      );
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const consultas = {
  indicadores,
  ativos,
  correlacao,
  correlacaoBenchmarks,
  cancel,
};

export default consultas;
